"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformItemRequest = exports.transformItemListResponse = exports.transformItemResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("./Money");
const Error_1 = require("./Error");
var VisState;
(function (VisState) {
    VisState[VisState["active"] = 0] = "active";
    VisState[VisState["deleted"] = 1] = "deleted";
})(VisState || (VisState = {}));
function transformItemResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { item } = response.response.result;
    return transformItemParsedResponse(item);
}
exports.transformItemResponse = transformItemResponse;
function transformItemListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { items, per_page, total, page, pages } = response.response.result;
    return {
        items: items.map((item) => transformItemParsedResponse(item)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformItemListResponse = transformItemListResponse;
function transformItemParsedResponse(item) {
    return {
        id: item.id.toString(),
        accountingSystemId: item.accounting_systemid,
        updated: new Date(item.updated),
        name: item.name,
        description: item.description,
        qty: item.qty,
        sku: item.sku,
        inventory: item.inventory,
        unitCost: (0, Money_1.transformMoneyParsedResponse)(item.unit_cost),
        tax1: item.tax1.toString(),
        tax2: item.tax2.toString(),
        visState: item.vis_state,
    };
}
function transformItemRequest(item) {
    return JSON.stringify({
        item: {
            name: item.name,
            description: item.description,
            qty: item.qty,
            sku: item.sku,
            inventory: item.inventory,
            unit_cost: item.unitCost && (0, Money_1.transformMoneyParsedRequest)(item.unitCost),
            tax1: item.tax1,
            tax2: item.tax2,
            vis_state: item.visState,
        },
    });
}
exports.transformItemRequest = transformItemRequest;
//# sourceMappingURL=Item.js.map